export default __webpack_public_path__ + "static/media/2.4f7bc702.jpg";